export const rememberEasyAssignPreferenceLocalStorageKey =
  'easyAssignPreference'

export const firebaseUserEngagementCollectionName = 'UserEngagement'
